import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { agentUserContext } from 'application/contexts/useAgentUser';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { AgentUserLogout } from 'application/usecases/AgentUserLogout';

export const useHeader = () => {
    const navigate = useNavigate();
    const diContainer = useContext(diContainerContext);
    const agentUserLogout = diContainer.resolve(AgentUserLogout);

    const { user, resetUser } = useContext(agentUserContext);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const handleLogout = async () => {
        await agentUserLogout.execute();
        window.location.href = '/agent/login/';
        resetUser();
    };

    const menuItems = [
        { text: 'マイページ', url: '/agent/dashboard/' },
        { text: 'ログアウト', url: '/agent/login/', handler: handleLogout },
    ];

    const onItemClick = (item: (typeof menuItems)[0]) => {
        setPopoverOpen(false);
        item.handler?.();
        if (item.url) navigate(item.url);
    };

    return {
        user,
        popoverOpen,
        setPopoverOpen,
        menuItems,
        onItemClick,
    };
};
